export default {"src":"/_next/static/media/new-edit-icon.c19101ee.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};